import { useContext } from 'react';
import {
  inertNotificationsValue,
  NotificationsContext,
  type NotificationsContextValue,
} from '../NotificationsContext';

export function useNotifications(): NotificationsContextValue {
  return useContext(NotificationsContext) ?? inertNotificationsValue;
}
